import React from 'react'
import {Helmet} from 'react-helmet'


export default () => {


  return (
    [
      <Helmet>
        <title> Page Not Found </title>
      </Helmet>,
      <div id="notfound"></div>
    ]
  )
}
